<nav mat-tab-nav-bar class="das-header" [style.backgroundColor]="headerBackgroundColour">
  <a routerLink="/" class="he-combined-logo" id="logo">
    <img src="/assets/national-highways-das.svg" alt="DAS Home" />
  </a>
  <a routerLink="/" class="he-single-logo" id="logo"> <img src="/assets/national-highways.svg" alt="DAS Home" /> </a>
  <tses-alt-accessibility
    class="logo"
    [altProperties]="accessibilityKeysService.getAltProperties(DasAccessibilityItem.HEADER_LOGO)"
    (onSelect)="handleAltSelection('logo')"
  ></tses-alt-accessibility>
  <a
    mat-tab-link
    *ngFor="let link of links"
    class="nav-tab"
    [routerLink]="link.path"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="rla.isActive"
    [id]="link.label"
  >
    <mat-icon>{{ link.icon }}</mat-icon>
    <span>{{ link.label }}</span>
    <tses-alt-accessibility
      class="tab-link"
      [altProperties]="link.altProperties"
      (onSelect)="handleAltSelection(link.label)"
    ></tses-alt-accessibility>
  </a>

  <div class="flex-grow"></div>

  <div class="buttons-right">
    <!-- Help links-->
    <a href="https://das-help.highwaysengland.co.uk" target="_blank" id="wiki-link" tabindex="-1">
      <button class="icon-button" mat-button aria-label="Help">
        <mat-icon>help</mat-icon>
        <span>Help</span>
        <tses-alt-accessibility
          class="menu"
          [altProperties]="accessibilityKeysService.getAltProperties(DasAccessibilityItem.HEADER_HELP)"
          (onSelect)="handleAltSelection('wiki-link')"
        ></tses-alt-accessibility>
      </button>
      <button class="icon-button mini" mat-icon-button aria-label="Help">
        <mat-icon>help</mat-icon>
        <tses-alt-accessibility
          class="menu"
          [altProperties]="accessibilityKeysService.getAltProperties(DasAccessibilityItem.HEADER_HELP)"
          (onSelect)="handleAltSelection('wiki-link')"
        ></tses-alt-accessibility>
      </button>
    </a>

    <!-- Contact support -->
    <button class="icon-button" id="feedback" mat-button aria-label="Contact support" (click)="feedback()">
      <mat-icon>email</mat-icon>
      <span>Contact Support</span>
      <tses-alt-accessibility
        class="menu"
        [altProperties]="
          accessibilityKeysService.getAltProperties(DasAccessibilityItem.HEADER_CONTACT_SUPPORT, !offline)
        "
        (onSelect)="handleAltSelection('feedback')"
      ></tses-alt-accessibility>
    </button>
    <button class="icon-button mini" mat-icon-button aria-label="Contact support" (click)="feedback()">
      <mat-icon>email</mat-icon>
      <tses-alt-accessibility
        class="menu"
        [altProperties]="
          accessibilityKeysService.getAltProperties(DasAccessibilityItem.HEADER_CONTACT_SUPPORT, !offline)
        "
        (onSelect)="handleAltSelection('feedback')"
      ></tses-alt-accessibility>
    </button>

    <!-- New Departure -->
    <button
      *ngIf="GlobalAction.CREATE_DEPARTURE | dasEnabled | async"
      (click)="create()"
      class="icon-button"
      color="primary"
      mat-raised-button
      [disabled]="creatingNewDeparture"
      aria-label="Create new departure"
    >
      <mat-icon>create</mat-icon>
      <span>New departure</span>
      <tses-alt-accessibility
        class="menu"
        [altProperties]="accessibilityKeysService.getAltProperties(DasAccessibilityItem.HEADER_NEW_DEPARTURE, !offline)"
        (onSelect)="create()"
      ></tses-alt-accessibility>
    </button>
    <button
      *ngIf="GlobalAction.CREATE_DEPARTURE | dasEnabled | async"
      (click)="create()"
      class="icon-button mini"
      color="primary"
      mat-icon-button
      [disabled]="creatingNewDeparture"
      aria-label="Create new departure"
    >
      <mat-icon>create</mat-icon>
      <tses-alt-accessibility
        class="menu"
        [altProperties]="accessibilityKeysService.getAltProperties(DasAccessibilityItem.HEADER_NEW_DEPARTURE, !offline)"
        (onSelect)="create()"
      ></tses-alt-accessibility>
    </button>

    <!-- User info -->
    <button
      mat-button
      [matMenuTriggerFor]="userMenu"
      #userMenuTrigger="matMenuTrigger"
      aria-label="User menu"
      class="icon-button"
      (focus)="openUserMenu()"
    >
      <mat-icon>person</mat-icon>
      <span class="full-name">{{ userFullName }}</span>
      <span class="first-name">{{ userFirstName }}</span>
      <tses-alt-accessibility
        class="menu"
        [altProperties]="accessibilityKeysService.getAltProperties(DasAccessibilityItem.HEADER_USER_MENU, !offline)"
        (onSelect)="openUserMenu()"
      ></tses-alt-accessibility>
    </button>
    <button
      mat-icon-button
      [matMenuTriggerFor]="userMenu"
      #userMenuTrigger="matMenuTrigger"
      aria-label="User menu"
      class="icon-button mini"
      (focus)="openUserMenu()"
    >
      <mat-icon>person</mat-icon>
      <tses-alt-accessibility
        class="menu"
        [altProperties]="accessibilityKeysService.getAltProperties(DasAccessibilityItem.HEADER_USER_MENU, !offline)"
        (onSelect)="openUserMenu()"
      ></tses-alt-accessibility>
    </button>
  </div>
  <tses-alt-accessibility
    class="initial"
    [altProperties]="accessibilityKeysService.getAltProperties(DasAccessibilityItem.HEADER)"
  ></tses-alt-accessibility>
</nav>

<div class="toolbar-container" *ngIf="toolbarVisible">
  <tses-toolbar></tses-toolbar>
</div>

<mat-menu #userMenu="matMenu" [overlapTrigger]="false">
  <ng-container *ngIf="GlobalAction.USER_MANAGEMENT | dasEnabled | async">
    <a mat-menu-item [href]="userManagementUrl()" target="_blank">User management</a>
  </ng-container>
  <ng-container *ngIf="GlobalAction.VIEW_USER_LOCATIONS | dasEnabled | async">
    <a mat-menu-item [href]="userLocationsUrl()">User locations</a>
  </ng-container>
  <a mat-menu-item [href]="accountManagementUrl()">Account management</a>
  <ng-container *ngIf="GlobalAction.VIEW_ADMIN_PAGE | dasEnabled | async">
    <a mat-menu-item routerLink="admin">Admin Page</a>
  </ng-container>
  <button mat-menu-item (click)="$event.stopPropagation()" (keydown.enter)="onKeyboardEnter()">
    <span>Show accessibility focus </span>
    <mat-slide-toggle
      color="primary"
      (change)="onToggle($event)"
      aria-label="toggle accessibility focus'"
      [checked]="accessibilityToggleChecked"
    ></mat-slide-toggle>
  </button>
  <a mat-menu-item [href]="logoutUrl()" (click)="forceLogout()">Logout</a>
</mat-menu>
<mat-progress-bar mode="indeterminate" *ngIf="loadingBarVisible"></mat-progress-bar>
